<template>
  <div class="container">
    <div class="shadow-wrapper padding-m flex-cc dir-col mb-m">
      <h1 class="mb-l">請輸入手機簡訊收到的驗證碼</h1>
      <img
        class="mb-m"
        src="@/assets/icon-phone.png"
        alt="磐石保經-簡訊驗證"
        :style="{width: '100px', height: '100px'}"
      >
      <div
        class="clearfix"
        :style="{maxWidth: '300px'}"
      >
        <Input
          v-model="authCode"
          class="mb-s"
          type="text"
          size="large"
          :maxlength="6"
        />
        <p class="fz-small">請於 10 分鐘內輸入，逾時將影響交易流程。</p>
      </div>
    </div>
    <div class="text-right">
      <span class="fz-small">
        距離重新發送認證碼的時間還有 
        <span :style="{color: '#2d8cf0'}">{{ second }}</span> 
        秒
      </span>
      <Button
        type="primary"
        size="large"
        :style="{margin: '0 15px'}"
        :disabled="resendDisabled"
        @click="handleResend"
        v-text="'重新發送驗證碼'"
      />
      <Button
        class="btn-m btn-primary"
        :disabled="verifyDisabled"
        @click="handleVerify(authCode)"
        v-text="'下一步'"
      />
    </div>
  </div>
</template>

<script>
  import { Input, Button } from 'iview';

  export default {
    components: { Input, Button },
    props: {
      isDevMode: {
        type: Boolean,
        default: () => process.env.NODE_ENV === 'development'
      },
      handleVerify: {
        type: Function,
        default: () => {}
      },
      resendOtp: {
        type: Function,
        default: () => {}
      },
      restOfCount: {
        type: Number,
        default: null
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        timer: null,
        second: this.isDevMode ? 2 : 60,
        countdownDisabled: true,
        authCode: '',
      };
    },
    computed: {
      resendDisabled() {
        const { countdownDisabled, restOfCount, loading } = this;
        return countdownDisabled || loading || !restOfCount;
      },
      verifyDisabled() {
        const { authCode, loading } = this;
        return authCode.length !== 6 || loading;
      }
    },
    mounted() {
      this.countdown();
    },
    beforeDestroy() {
      this.clearTimer();
    },
    methods: {
      countdown() {
        this.countdownDisabled = true;
        this.timer = setInterval(() => {
          if (this.second !== 0) {
            this.second -= 1;
            return;
          }
          this.countdownDisabled = false;
          this.clearTimer();
        }, 1000);
      },
      clearTimer() {
        clearInterval(this.timer);
      },
      async handleResend() {
        if (!this.restOfCount) return;
        await this.resendOtp();
        this.second = this.isDevMode ? 2 : 60;
        this.countdown();
      }
    }
  };
</script>
